// DomText
import Linkify from 'react-linkify';
import React from 'react';

import DomLink from './DomLink';

export default class DomText extends React.Component {
  render() {
    if (!this.props.text) {
      return <span></span>;
    }

    return (
      <span>
      {
        this.props.text.split("\n").map(function(line, i) {
          return (
            <Linkify key={'line'+i} properties={{target:'_blank'}}>{line}<br /></Linkify>
          )
        })
      }
      </span>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/DomText.jsx